import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=455dc7c5&scoped=true&"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=455dc7c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455dc7c5",
  null
  
)

export default component.exports